import { Heading } from '@cinch-labs/design-system'
import { FindStoreCard, FindStoreSection } from '../../types/store-hub'

import styles from './store-hub-list.module.css'
import { ChevronRightIcon } from '../assets/chevron-right-icon'
import { LocationIcon } from '../assets/location-icon'
import { useViewport } from '@cinch-labs/shared-util'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
export interface StoreHubListProps {
  findStoreList: FindStoreSection
}

export const StoreCard = (store: FindStoreCard) => {
  const { title, address, url } = store
  const { cached_url } = url
  const { vw } = useViewport({
    updateOnResize: true,
    updateOnOrientationChange: true,
  })
  const isMobile = vw < 1024
  const cardCategory = 'find a cinch store'
  const { trackEvent } = useAnalytics()

  const slug = cached_url.split('/')[1]

  const handleClick = () => {
    trackEvent({
      eventName: `cinch stores hub - ${cardCategory}`,
      type: TrackingEventTypes.ADOBE,
      data: {
        action: 'select',
        event: {
          name: EventNames.click,
          category: cardCategory,
          label: slug,
        },
      },
    })
    window.location.assign(`/${cached_url}`)
  }

  return (
    <div className={styles.cardWrapper} onClick={() => handleClick()}>
      <div className={styles.detailsSection}>
        <Heading element="h3" className={styles.subtitle}>
          {title}
        </Heading>
        <div className={styles.addressLine}>
          {!isMobile && <LocationIcon />}
          <p>{address}</p>
        </div>
      </div>
      <div className={styles.chevronIcon}>
        <ChevronRightIcon size={vw < 768 ? 'small' : 'large'} />
      </div>
    </div>
  )
}
export const StoreHubList = ({ findStoreList }: StoreHubListProps) => {
  const { title, stores } = findStoreList
  return (
    <section className={styles.componentWrapper}>
      <Heading element="h2">{title}</Heading>
      <div className={styles.listWrapper}>
        {stores.map((store, index) => (
          <StoreCard key={`store-card-${index}`} {...store} />
        ))}
      </div>
    </section>
  )
}
